import * as React from "react";
import { IconProps } from "./types";

export const ArrowNarrowUpLeftIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M18 18L6 6M6 6V14M6 6H14"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ArrowNarrowUpLeftIcon as React.FunctionComponent).displayName =
  "ArrowNarrowUpLeftIcon";

export default ArrowNarrowUpLeftIcon;
